function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_TPL_FIELDS, DEFAULT_TPL_COLUMNS, TYPE_CHANGE_METADA, ACCESS_TYPE_FLOW, envConfig, isFOHDomain } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { changesMedatada } from '@/mixins/changes_metadata';
import PaginationFirestore from '@/components/PaginationFirestore.vue';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
var BIGQUERY_TYPES = ['INT64', 'INT', 'SMALLINT', 'INTEGER', 'BIGINT', 'TINYINT', 'BYTEINT', 'NUMERIC', 'DECIMAL', 'BIGNUMERIC', 'BIGDECIMAL', 'FLOAT64', 'BOOL', 'BOOLEAN', 'STRING', 'BYTES', 'DATE', 'TIME', 'DATETIME', 'TIMESTAMP', 'GEOGRAPHY', 'JSON'];
export default {
  name: 'ListTableMetadataColsComponent',
  mixins: [changesMedatada],
  components: {
    PaginationFirestore: PaginationFirestore
  },
  props: {
    changes: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    columnFields: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    defaultFields: {
      type: Object,
      required: true
    },
    isChangeRequest: {
      type: String,
      required: false,
      default: TYPE_CHANGE_METADA.UPDATE
    },
    showFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true
    },
    isRequestView: {
      type: Boolean,
      required: false,
      default: false
    },
    isOwnerApproval: {
      type: Boolean,
      required: false,
      default: false
    },
    isRequiredEnable: {
      type: Boolean,
      required: false,
      default: true
    },
    columns_selected: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    lazyLoadParams: {
      type: Object,
      required: false,
      default: function _default() {
        return null;
      }
    },
    // Fuerza mostrar Lógica de transformación aunque aplique el ocultamiento FOH
    // (lo usa la pantalla de comparación de solicitudes de cambio)
    showTransformationLogic: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      rules: {
        required: function required(v) {
          return v !== 'Null' && !!v || _this.$t('my_tasks.modals.required');
        },
        bigQueryType: function bigQueryType(v) {
          return v == null || v === 'Null' || BIGQUERY_TYPES.includes(String(v).toUpperCase()) || _this.$t('my_tasks.modals.invalid_bigquery_type');
        }
      },
      tableRoles: null,
      inputSearch: '',
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      DEFAULT_TPL_COLUMNS: DEFAULT_TPL_COLUMNS,
      filter: '',
      perPage: envConfig.TABLE_TAGS_LIMIT,
      currentPage: 1,
      totalRows: 1,
      columnFieldsLabels: [{
        text: 'Column',
        value: 'column',
        sortable: true
      }, {
        text: 'Data Element Name',
        value: 'fields_data_element_name_stringValue',
        sortable: true
      }, {
        text: 'Business Definition',
        value: 'fields_business_definition_stringValue',
        sortable: true
      }, {
        text: 'Transformation Logic',
        value: 'fields_transformation_logic_stringValue',
        sortable: true
      }, {
        text: 'Type',
        value: 'fields_type_stringValue',
        sortable: true,
        width: 150
      }, {
        text: 'Length',
        value: 'fields_length_stringValue',
        sortable: true
      }, {
        text: 'Valid Values',
        value: 'fields_valid_values_stringValue',
        sortable: true
      }, {
        text: 'Primary Key',
        value: 'primary_key_boolValue',
        sortable: true
      }, {
        text: 'Sensitive',
        value: 'fields_sensitive_boolValue',
        sortable: true
      }, {
        text: 'null',
        value: 'fields_null_boolValue',
        sortable: true
      }, {
        text: 'Encrypted',
        value: 'fields_encrypted_boolValue',
        sortable: true
      }, {
        text: 'Load Logic',
        value: 'fields_load_logic_stringValue',
        sortable: true
      }],
      filterOn: [],
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0,
        next: null
      },
      key_table: 1,
      columns_selected_items: [],
      localColumnFields: [],
      isLoadingColumns: false,
      cursor: 0,
      isLoadingSearch: false,
      searchTextInput: '',
      expanded: [],
      viewMode: 'expanded'
    };
  },
  created: function created() {
    var _this2 = this;
    this.tableRoles = utils.getOwnersAndStewards(this.defaultFields);
    if (this.isChangeRequest === TYPE_CHANGE_METADA.VIEWER_ONLY && this.lazyLoadParams) {
      this.localColumnFields = [];
      this.loadColumnsLazy();
    } else {
      this.localColumnFields = _toConsumableArray(this.columnFields);
      this.localColumnFields.forEach(function (objeto) {
        if (_this2.columns_selected.includes(objeto.column)) {
          objeto.included = true;
        }
      });
    }
    var data = {
      text: 'Required',
      value: 'include_in_flow',
      tdClass: 'td-required',
      thClass: 'th-required'
    };
    this.columnFieldsLabels.unshift(data);
    this.pagination.total = this.localColumnFields.length;
  },
  mounted: function mounted() {
    this.totalRows = this.localColumnFields.length;
    this._setupTableScrollSync();
    this.$el.addEventListener('invalid', this._handleInvalid, true);
  },
  beforeDestroy: function beforeDestroy() {
    this.$el.removeEventListener('invalid', this._handleInvalid, true);
  },
  watch: {
    viewMode: function viewMode() {
      var _this3 = this;
      this.$nextTick(function () {
        return _this3._setupTableScrollSync();
      });
    }
  },
  computed: {
    searchFilter: function searchFilter() {
      if (this.lazyLoadParams && this.isChangeRequest === TYPE_CHANGE_METADA.VIEWER_ONLY) {
        return '';
      }
      return this.filter;
    },
    displayColumnFields: function displayColumnFields() {
      return this.localColumnFields;
    },
    headers: function headers() {
      var options = [{
        text: this.traductor('my_tasks.modals.column'),
        value: 'column',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.data_element'),
        value: 'fields_data_element_name_stringValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.bdefinition'),
        value: 'fields_business_definition_stringValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.sensitive'),
        value: 'fields_sensitive_boolValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.type'),
        value: 'fields_type_stringValue',
        sortable: true,
        width: 150
      }, {
        text: this.traductor('my_tasks.modals.length'),
        value: 'fields_length_stringValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.valid_values'),
        value: 'fields_valid_values_stringValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.primary_key'),
        value: 'primary_key_boolValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.null'),
        value: 'fields_null_boolValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.encrypted'),
        value: 'fields_encrypted_boolValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.load_logic'),
        value: 'fields_load_logic_stringValue',
        sortable: true
      }];
      // Lógica de transformación: oculta para FOH/local salvo en la pantalla de
      // comparación de solicitudes de cambio (showTransformationLogic)
      if (!this.hideTransformationLogic) {
        options.splice(3, 0, {
          text: this.traductor('my_tasks.modals.transformation_logic'),
          value: 'fields_transformation_logic_stringValue',
          sortable: true
        });
      }
      var requiredCol = {
        text: 'Required',
        value: 'include_in_flow',
        tdClass: 'td-required',
        thClass: 'th-required'
      };
      options.unshift(requiredCol);
      return options;
    },
    summaryHeaders: function summaryHeaders() {
      return [{
        text: 'Req.',
        value: 'include_in_flow',
        sortable: true,
        width: '50px'
      }, {
        text: this.traductor('my_tasks.modals.column'),
        value: 'column',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.data_element'),
        value: 'fields_data_element_name_stringValue',
        sortable: true
      }, {
        text: this.traductor('my_tasks.modals.type'),
        value: 'fields_type_stringValue',
        sortable: true,
        width: '110px'
      }, {
        text: this.traductor('my_tasks.modals.length'),
        value: 'fields_length_stringValue',
        sortable: true,
        width: '80px'
      }, {
        text: this.traductor('my_tasks.modals.sensitive'),
        value: 'fields_sensitive_boolValue',
        sortable: true,
        width: '80px'
      }, {
        text: this.traductor('my_tasks.modals.null'),
        value: 'fields_null_boolValue',
        sortable: true,
        width: '70px'
      }, {
        text: this.traductor('my_tasks.modals.primary_key'),
        value: 'primary_key_boolValue',
        sortable: true,
        width: '80px'
      }, {
        text: this.traductor('my_tasks.modals.encrypted'),
        value: 'fields_encrypted_boolValue',
        sortable: true,
        width: '90px'
      }];
    },
    rulesBusinessDefinition: function rulesBusinessDefinition() {
      if (isFOHDomain(window.userInfo.domain)) {
        var required = this.getRequired(this.DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION);
        if (!required) return [];
        return [this.rules.required];
      }
      return [];
    },
    isFOH: function isFOH() {
      return isFOHDomain(window.userInfo.domain);
    },
    // Lógica de transformación oculta para FOH/local, salvo que el contenedor
    // pida mostrarla (pantalla de comparación de solicitudes de cambio)
    hideTransformationLogic: function hideTransformationLogic() {
      if (this.showTransformationLogic) return false;
      return isFOHDomain(window.userInfo.domain) || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    },
    // Tipo, Tamaño y Nulo solo lectura: aplica únicamente a dominios FOH
    // y, para poder probarlo, siempre en entorno local.
    lockSchemaColumns: function lockSchemaColumns() {
      return this.isFOH || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    }
  },
  methods: {
    _setupTableScrollSync: function _setupTableScrollSync() {
      var wrapper1 = this.$el.querySelector('.table-reference .v-data-table__wrapper');
      var wrapper2 = this.$el.querySelector('#wrapper2');
      if (wrapper1 && wrapper2) {
        wrapper1.onscroll = function () {
          wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function () {
          wrapper1.scrollLeft = wrapper2.scrollLeft;
        };
      }
    },
    onClickRow: function onClickRow(item) {
      var isExpanded = this.expanded.length > 0 && this.expanded[0].column === item.column;
      this.expanded = isExpanded ? [] : [item];
    },
    // Ordenamiento personalizado: los headers usan claves planas pero los datos están anidados
    // en item.fields[nombre][tipo]. Este sort resuelve el valor real de cada columna.
    // En columnas booleanas (sensible, nulo, llave primaria, encriptado) el primer clic deja
    // los marcados (true) primero.
    sortItemValue: function sortItemValue(item, key) {
      if (!item) return '';
      if (key === 'column') return String(item.column || '').toLowerCase();
      if (key === 'include_in_flow') {
        var sens = item.fields && item.fields[this.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
        if (this.isRequestView && sens) {
          return sens.include_in_flow === this.ACCESS_TYPE_FLOW.INCLUDED ? 0 : 1;
        }
        return item.included ? 0 : 1;
      }
      var isBool = /_boolValue$/.test(key);
      var name = key.replace(/^fields_/, '').replace(/_(boolValue|stringValue)$/, '');
      var field = item.fields && item.fields[name];
      if (!field) return isBool ? 1 : '';
      if (isBool) return field.boolValue === true ? 0 : 1; // true primero en orden ascendente
      var raw = field.stringValue;
      if (name === this.DEFAULT_TPL_COLUMNS.LENGTH.name) {
        var n = parseFloat(raw);
        if (!isNaN(n)) return n;
      }
      return String(raw == null ? '' : raw).toLowerCase();
    },
    customSort: function customSort(items, sortBy, sortDesc) {
      var key = Array.isArray(sortBy) ? sortBy[0] : sortBy;
      var desc = Array.isArray(sortDesc) ? sortDesc[0] : sortDesc;
      if (!key) return items;
      var self = this;
      var sorted = items.slice().sort(function (a, b) {
        var va = self.sortItemValue(a, key);
        var vb = self.sortItemValue(b, key);
        if (va < vb) return -1;
        if (va > vb) return 1;
        return 0;
      });
      if (desc) sorted.reverse();
      return sorted;
    },
    _handleInvalid: function _handleInvalid(event) {
      var panel = event.target.closest('.expanded-item-panel');
      if (!panel) return;
      var column = panel.dataset.column;
      var item = this.displayColumnFields.find(function (i) {
        return i.column === column;
      });
      if (item) {
        this.expanded = [item];
        this.$nextTick(function () {
          return event.target.focus();
        });
      }
    },
    focusFirstError: function focusFirstError() {
      var errorEl = this.$el.querySelector('.v-input.error--text input, .v-input.error--text textarea');
      if (!errorEl) return;
      var panel = errorEl.closest('.expanded-item-panel');
      if (panel) {
        var item = this.displayColumnFields.find(function (i) {
          return i.column === panel.dataset.column;
        });
        if (item) {
          this.viewMode = 'expanded';
          this.expanded = [item];
          this.$nextTick(function () {
            return errorEl.focus();
          });
        }
      } else {
        errorEl.focus();
      }
    },
    onSearchInput: function onSearchInput() {
      if (!this.lazyLoadParams || this.isChangeRequest !== TYPE_CHANGE_METADA.VIEWER_ONLY) {
        this.filter = this.inputSearch;
        return;
      }
      this.searchTextInput = this.inputSearch;
      this.searchColumnsLazy();
    },
    searchColumnsLazy: function searchColumnsLazy() {
      var self = this;
      if (!this.lazyLoadParams) return;
      this.isLoadingSearch = true;
      this.isLoadingColumns = true;
      this.cursor = 0;
      this.localColumnFields = [];
      var params = {
        relativeResourceName: this.lazyLoadParams.relativeResourceName,
        domain_table: this.lazyLoadParams.domain_table,
        source: this.lazyLoadParams.source || 'bigquery',
        limit: this.pagination.limit || 10,
        cursor: 0,
        text_filter: this.searchTextInput || ''
      };
      AssignmentsService.getListTagEntryPaginated(params).then(function (response) {
        self.isLoadingSearch = false;
        self.isLoadingColumns = false;
        if (response && response.code === 200) {
          var responseTPL = response.data || response;
          var items = responseTPL.objects && responseTPL.objects.items ? responseTPL.objects.items.tags : [];
          var itemsObj = responseTPL.objects || {};
          var nextCursor = itemsObj.nextCursor || itemsObj.next_cursor || null;
          var total = itemsObj.total || responseTPL.objects.items && responseTPL.objects.items.totalSize || 0;
          var newColumnFields = [];
          for (var i = 0; i < items.length; i++) {
            var tag = items[i];
            if (tag.column) newColumnFields.push({
              column: tag.column,
              fields: tag.fields
            });
          }
          self.localColumnFields = newColumnFields;
          self.cursor = nextCursor || 0;
          self.pagination.total = total;
          self.pagination.next = nextCursor;
          self.totalRows = newColumnFields.length;
          self.key_table += 1;
        }
      }).catch(function (error) {
        self.isLoadingSearch = false;
        self.isLoadingColumns = false;
        console.error('Error searching columns:', error);
      });
    },
    loadColumnsLazy: function loadColumnsLazy() {
      var self = this;
      if (!this.lazyLoadParams) return;
      this.isLoadingColumns = true;
      var params = {
        relativeResourceName: this.lazyLoadParams.relativeResourceName,
        domain_table: this.lazyLoadParams.domain_table,
        source: this.lazyLoadParams.source || 'bigquery',
        limit: this.pagination.limit || 10,
        cursor: this.cursor || 0,
        text_filter: this.searchTextInput || ''
      };
      AssignmentsService.getListTagEntryPaginated(params).then(function (response) {
        self.isLoadingColumns = false;
        if (response && response.code === 200) {
          var responseTPL = response.data || response;
          var items = responseTPL.objects && responseTPL.objects.items ? responseTPL.objects.items.tags : [];
          var itemsObj = responseTPL.objects || {};
          var nextCursor = itemsObj.nextCursor || itemsObj.next_cursor || null;
          var total = itemsObj.total || responseTPL.objects.items && responseTPL.objects.items.totalSize || 0;
          var newColumnFields = [];
          for (var i = 0; i < items.length; i++) {
            var tag = items[i];
            if (tag.column) newColumnFields.push({
              column: tag.column,
              fields: tag.fields
            });
          }
          self.localColumnFields = self.localColumnFields.concat(newColumnFields);
          self.cursor = nextCursor || 0;
          self.pagination.total = total;
          self.pagination.next = nextCursor;
          self.totalRows = self.localColumnFields.length;
          self.key_table += 1;
        }
      }).catch(function (error) {
        self.isLoadingColumns = false;
        console.error('Error loading columns:', error);
      });
    },
    changePage: function changePage(page) {
      this.pagination.current = page;
      if (this.lazyLoadParams && this.pagination.next) {
        this.loadColumnsLazy();
      }
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSelectItem: function onSelectItem(event) {
      console.log(event);
      this.key_table += 1;
      this.$emit('onSelectItem');
    },
    isEnable: function isEnable(item) {
      return this.isOwnerApproval ? this.isResponseEnable(item) : this.isRequestEnable();
    },
    getPattern: function getPattern(objEnvironment) {
      if (objEnvironment.name === DEFAULT_TPL_COLUMNS.TYPE.name) {
        var types = BIGQUERY_TYPES.join('|');
        return "^\\s*(?:".concat(types, ")\\s*$");
      }
      return tasks.getPattern(objEnvironment, this.defaultFields);
    },
    getRequired: function getRequired(objEnvironment) {
      return tasks.getRequired(objEnvironment, this.defaultFields);
    },
    isResponseEnable: function isResponseEnable(item) {
      var sensitiveField = item.fields[this.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
      var valueSencible = sensitiveField[this.DEFAULT_TPL_COLUMNS.SENSITIVE.type];
      if (!sensitiveField.original_request_value) {
        sensitiveField.original_request_value = sensitiveField.include_in_flow;
      }
      if (valueSencible && sensitiveField.original_request_value === this.ACCESS_TYPE_FLOW.INCLUDED) {
        return true;
      }
      return false;
    },
    isRequestEnable: function isRequestEnable() {
      return this.isRequiredEnable;
    },
    isEdited: function isEdited(FIELD_NAME) {
      return utils.fieldIsEdited(FIELD_NAME, this.tableRoles, this.isChangeRequest);
    },
    rowClassSensitive: function rowClassSensitive(item) {
      if (!item) return;
      if (item.fields.sensitive.boolValue === true) return 'sensitive_column';
      return true;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};